"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Returns a deep copy of the provided object
 * @param {object} inObject - the input object
 * @returns {object} Deep copy of input object
 */
function deepCopy(inObject) {
  if (typeof inObject !== 'object' || Object.prototype.toString.call(inObject) === '[object Date]' || inObject === null) {
    return inObject;
  }

  const outObject = Array.isArray(inObject) ? [] : {};
  Object.keys(inObject).forEach(key => {
    outObject[key] = deepCopy(inObject[key]);
  });
  return outObject;
}

var _default = {
  deepCopy
};
exports.default = _default;